import Auth from '../../auth/auth';
export const loginActions ={
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE'
  }


  const auth = new Auth();


//--------- Login -----------

export function loginRequest(credentials){
  return function(dispatch){
    dispatch({ type: loginActions.LOGIN_REQUEST });
      return fetch(process.env.REACT_APP_API_URL+'/auth/login', {
      method: "POST",
      body: JSON.stringify(credentials),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    })
    .then(response =>
       response.json().then(user => ({ user, response }))
           ).then(async ({ user, response }) =>  {
       if (!response.ok) {
         dispatch({ type: loginActions.LOGIN_FAILURE});
       } else {
         //console.log("user",user);
         await auth.setSession(user);
         dispatch({ type: loginActions.LOGIN_SUCCESS});
       }
     }).catch(err => console.log("Error: ", err))
   }
}
